module.exports = __webpack_public_path__ + "img/plp-careplan-image-banner-expert.fac5191.webp";